module.exports = __webpack_public_path__ + "static/img/5-2.a747af4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/5-2.jpg
// module id = bPxx
// module chunks = 0